import { render, staticRenderFns } from "./motNovedades.vue?vue&type=template&id=0ebd824e&scoped=true&"
import script from "./motNovedades.vue?vue&type=script&lang=js&"
export * from "./motNovedades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebd824e",
  null
  
)

export default component.exports